import { setDate, setMonth, setYear, startOfDay } from 'date-fns'
import { est } from '../utilities/date'

export interface NamedDate {
  name: string;
  value: () => Date
}

export const NON_TERMINATING_NAMED_DATE: NamedDate = {
  name: 'Non-terminating',
  value: () => startOfDay(setDate(setMonth(setYear(est(), 9999), 0), 1)),
}
